import { useEffect, useState } from 'react';

const loadImage = async (imageSrc: string) => {
  return new Promise((resolve, reject) => {
    const loadImg = new Image();
    loadImg.src = imageSrc;
    loadImg.onload = () => resolve(imageSrc);
    loadImg.onerror = (err) => reject(err);
  });
};

export const useLoadImages = (imgSrcs: string[]) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    Promise.all(imgSrcs.map(async (image) => loadImage(image)))
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false));
  }, [imgSrcs]);

  return { isLoading, isError };
};